var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"log-line"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_setup.messageTime))]),_c({render:_setup.dynamicMessage},{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }